<img
  [attr.class]="class"
  [src]="srcUrl"
  role="presentation"
  aria-hidden="true"
  [alt]="altText"
  (error)="handleMissingImage()">
